"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const valueIsString_1 = __importDefault(require("../../../typeAssertions/valueIsString"));
const valueIsBoolean_1 = __importDefault(require("../../../typeAssertions/valueIsBoolean"));
const JitsiMeetRenderer = ({ control, style, }) => {
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const renderWithWrapper = (content) => (react_1.default.createElement(Render.View, { style: { width: style.width, height: style.height } }, content));
    const { roomId, displayName, email, triggerCall, endCall, } = control;
    if (!roomId || !(0, valueIsString_1.default)(roomId)) {
        return renderWithWrapper(react_1.default.createElement(Render.View, null,
            react_1.default.createElement(Render.Text, null, "Meet without room id")));
    }
    if (!displayName || !(0, valueIsString_1.default)(displayName)) {
        return renderWithWrapper(react_1.default.createElement(Render.View, null,
            react_1.default.createElement(Render.Text, null, "Meet without display name")));
    }
    if (!email || !(0, valueIsString_1.default)(email)) {
        return renderWithWrapper(react_1.default.createElement(Render.View, null,
            react_1.default.createElement(Render.Text, null, "Meet without email")));
    }
    return renderWithWrapper(react_1.default.createElement(Render.JitsiMeet, { style: { width: '100%', height: '100%' }, roomId: roomId, displayName: displayName, email: email, triggerCall: (0, valueIsBoolean_1.default)(triggerCall) ? triggerCall : false, endCall: (0, valueIsBoolean_1.default)(endCall) ? endCall : false }));
};
exports.default = JitsiMeetRenderer;
